//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import excelDownload from 'js-file-download'
import { questionOwnerType } from '@/server/constants'
import CopyQuestionsModal from '@/components/shared/CopyQuestionsModal.vue'
import UpdateQuestionsModal from '@/components/shared/UpdateQuestionsModal.vue'
import RfiImportModal from '@/components/templates/RfiImportModal.vue'

export default {
  name: 'Template',
  components: {
    CopyQuestionsModal,
    UpdateQuestionsModal,
    RfiImportModal
  },
  data() {
    return {
      file: {},
      errorMsg: null,
      // Org A.I. import token balance for the dropdown item (a failed fetch leaves it
      // enabled — the server enforces the balance regardless).
      importTokens: 0,
      tokensLoaded: false
    }
  },
  async mounted() {
    if (!this.showEditImportButtons) { return }
    try {
      this.importTokens = await this.fetchImportTokens()
      this.tokensLoaded = true
    } catch (err) { /* balance unknown */ }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'breakpoints/desktop',
      isProjectOwner: 'user/isProjectOwner',
      loading: 'global/loading',
      questionsSelect: 'questions/getQuestionsSelect',
      questionsSelected: 'questions/getQuestionsSelected',
      questionsSelectActive: 'questions/getQuestionsSelectActive',
      template: 'templates/getActiveTemplate',
      isAdmin: 'user/isAdmin',
      searchMatchedQuestions: 'questions/getSearchMatchedQuestions'
    }),
    questionSearchActive() {
      return this.searchMatchedQuestions !== null
    },
    clearLabel() {
      return this.questionsSelected.length ? `Clear (${this.questionsSelected.length})` : 'Clear'
    },
    isSystemTemplate() {
      return this.template && !this.template.user && !this.template.org
    },
    showEditImportButtons() {
      return this.isSystemTemplate ? this.isAdmin : true
    },
    importAvailable() {
      return !this.tokensLoaded || this.importTokens > 0
    }
  },
  beforeDestroy() {
    // Clear question selection when leaving the template page
    this.setQuestionsSelect({ project: {}, property: {}, status: false, questions: [] })
  },
  methods: {
    ...mapActions({
      fetchImportTokens: 'rfiImport/fetchImportTokens',
      fetchAllQuestionsForSelection: 'questions/fetchAllQuestionsForSelection',
      fetchPrimaryCategories: 'questions/fetchPrimaryCategories',
      setQuestionsSelect: 'questions/setQuestionsSelect',
      setQuestionsSelectActive: 'questions/setQuestionsSelectActive',
      setQuestionsSelected: 'questions/setQuestionsSelected',
      setQuestionsSelectProject: 'questions/setQuestionsSelectProject',
      setQuestionsSelectProperty: 'questions/setQuestionsSelectProperty',
      startLoading: 'global/startLoading',
      stopLoading: 'global/stopLoading'
    }),
    addTemplateQuestion(template) {
      if (!template || !template._id) {
        console.error('Template not available for adding question')
        return
      }
      // we are prefilling AddEditQuestion categories if user navigates to that page with referred: true only
      this.$router.push({
        path: `/templates/${template._id}/add-question`,
        query: { referred: true }
      })
    },
    editQuestion(question) {
      if (!this.template || !this.template._id) {
        console.error('Template not available for editing question')
        return
      }
      this.$router.push(`/templates/${this.template._id}/question/${question._id}/edit-question`)
    },
    async refreshCategories() {
      if (!this.template || !this.template._id) {
        console.error('Template not available for refreshing categories')
        return
      }
      await this.fetchPrimaryCategories({ owner: this.template._id, type: questionOwnerType.template })
      localStorage.removeItem('categoryselections')
    },
    async exportTemplate(template) {
      const response = await this.$axios.get(`/export/template/${template._id}`, { responseType: 'arraybuffer' })
      excelDownload(response.data, 'template-export.xlsx')
    },
    triggerLassoUpload() {
      this.$refs.lassoFileInput.click()
    },
    onLassoFileSelected(e) {
      const file = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) {
        return
      }
      this.file = file
      this.importTemplate(this.template)
    },
    openAiImport() {
      this.$refs.rfiImportModal.show()
    },
    async importTemplate(template) {
      const data = new FormData()
      data.append('template', this.file)
      try {
        const res = await this.$axios.$post(`/import/template/${template._id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        if (res.result === 'ok') {
          await this.refreshCategories()
          this.successNotification()
          return
        }
      } catch (error) {
        const { response: { data } = {} } = error
        this.errorMsg = data
        await this.refreshCategories()
      }
    },
    successNotification() {
      const h = this.$createElement
      const customMsg = h(
        'div',
        [
          'Questions were successfully imported into template ',
          h('strong', `"${this.template.name}". `)
        ]
      )
      this.$bvToast.toast([customMsg], {
        autoHideDelay: 2000,
        noCloseButton: true,
        solid: true,
        toaster: 'b-toaster-top-right',
        title: 'Success',
        variant: 'success'
      })
    },
    async addAllQuestions() {
      if (!this.template || !this.template._id) {
        console.error('Template not available for adding questions')
        return
      }
      // With an active search, select only the questions matching the filter
      if (this.searchMatchedQuestions) {
        this.setQuestionsSelected(this.searchMatchedQuestions)
        return
      }
      await this.fetchAllQuestionsForSelection({ owner: this.template._id, type: 1, viewPhase: false })
    },
    toggleSelectQuestions() {
      if (!this.template || !this.template._id) {
        console.error('Template not available for selecting questions')
        return
      }
      if (this.questionsSelect.questionsSelectActive) {
        this.setQuestionsSelect({ project: {}, property: {}, status: false, questions: [] })
      } else {
        this.setQuestionsSelectProject({ _id: this.template._id, name: this.template.name })
        this.setQuestionsSelectProperty({ _id: null, name: '', address: null })
        this.setQuestionsSelectActive(true)
      }
    },
    showCopyModal() {
      this.$refs.copyModal.showCopyModal()
    },
    showUpdateModal() {
      this.$refs.updateModal.show()
    },
    refreshQuestions() {
      if (this.$refs.categoriesQuestions) {
        this.$refs.categoriesQuestions.refreshCategories()
      }
    }
  }
}
